import { Pipe, PipeTransform } from '@angular/core';
import { CommentChatModel, isCommentDeleted } from '@dta/shared/models-api-loop/comment/comment.model';

@Pipe({
  name: 'isCommentDeleted',
  standalone: false
})
export class IsCommentDeletedPipe implements PipeTransform {
  transform(comment: CommentChatModel): boolean {
    return isCommentDeleted(comment);
  }
}
